import { Component, EventEmitter, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { FormBuilder, Validators } from '@angular/forms'
import { NotificationService } from '../notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-delete-geo-fencing',
  templateUrl: './delete-geo-fencing.component.html',
  styleUrls: ['./delete-geo-fencing.component.scss']
})
export class DeleteGeoFencingComponent implements OnInit {
  isDeleted = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,private notification:NotificationService,private fb: FormBuilder,public service:CommonService,private snack:MatSnackBar ,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<DeleteGeoFencingComponent>) { }

  ngOnInit(): void {
  }
  customerDelete(){
    this.service.dltgeofence(this.data)
    .subscribe((res:any)=>{
      if(res.message == "Success"){
        // this.snack.open("Deleted successfully",'',{
        //   duration:3000,
        //  verticalPosition:'top',
        //  horizontalPosition: 'end',
        this.notification.showInfo("Deleted successfully",'')

        // })
        this.isDeleted.emit(true)
        this.dialogRef.close();
        
      }else{
        alert("something went wrong");
      }
     
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
